$(document).ready(function () {
  if ($("#datetimepicker").length) {
    $.datetimepicker.setLocale("ru");

    $("#datetimepicker").datetimepicker({
      i18n: {
        de: {
          months: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
          ],
          dayOfWeek: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        },
      },
      timepicker: false,
      format: "d/m/Y",
      theme: "dark",
    });
  }

  if ($("#calendarMatches").length) {
    $.datetimepicker.setLocale("ru");

    $("#calendarMatches").datetimepicker({
      i18n: {
        de: {
          months: [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
          ],
          dayOfWeek: ["ВС", "ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ"],
        },
      },
      timepicker: false,
      format: "Y-m-d",
      theme: "dark",
      onSelectDate: function (dp, $input) {
        $(".forecasts__wrapper").html(
          '<p class="forecast__response__text">Идет загрузка...</p>'
        );
        $(".matches__inner__btn").removeClass("matches__inner__btn--active");
        $("#forecastLoadMore").hide();
        const sportId = $input.data("sport-id");
        const date = $input.val();

        $.ajax({
          method: "POST",
          url: "/ajax/forecastscalendar",
          data: { date: date, sportId: sportId },
        }).done(function (resp) {
          if (resp != "") {
            $(".forecasts__wrapper").html(resp);
          } else {
            $(".forecasts__wrapper").html(
              '<p class="forecast__response__text">На выбранную дату прогнозов нет</p>'
            );
          }
        });
      },
    });
  }
});
